import "./views/movie/shared/partials/_rottenTomatoesRating.js";
import "./views/movie/mobile/partials/_audienceScoreMoreInfo.js";
import "./views/movie/shared/partials/_datePickerFutureDateCta.js";
import "./views/movie/shared/partials/_datePicker.js";